import clsx from 'clsx';
import Script from 'next/script';
import { useEffect } from 'react';
import { setIsChannelShow, useEnableChannelTalk, useIsChannelShow } from './ChannelTalkStore';

declare global {
  interface Window {
    ChannelIO?: IChannelIO;
  }
}

interface IChannelIO {
  c?: (...args: any) => void;
  q?: [methodName: string, ...args: any[]][];
  (...args: any): void;
}

const CHANNEL_TALK_PLUGIN_KEY = '8a6804e8-a7fc-4a7a-8955-87d8a915959e';
const CHANNEL_TALK_LOADING_SCRIPT = `(function(){var w=window;if(w.ChannelIO){return w.console.error("ChannelIO script included twice.")}var ch=function(){ch.c(arguments)};ch.q=[];ch.c=function(args){ch.q.push(args)};w.ChannelIO=ch;function l(){if(w.ChannelIOInitialized){return}w.ChannelIOInitialized=true;var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";var x=document.getElementsByTagName("script")[0];if(x.parentNode){x.parentNode.insertBefore(s,x)}}if(document.readyState==="complete"){l()}else{w.addEventListener("DOMContentLoaded",l);w.addEventListener("load",l)}})();`;

export function ChannelTalk(): JSX.Element {
  const isChannelShow = useIsChannelShow();
  const enableChannelTalk = useEnableChannelTalk();

  useEffect(() => {
    window.ChannelIO?.('boot', {
      pluginKey: CHANNEL_TALK_PLUGIN_KEY,
      customLauncherSelector: '.custom-channel-talk',
      hideChannelButtonOnBoot: true,
    });

    if (enableChannelTalk) {
      window.ChannelIO('onShowMessenger', () => {
        setIsChannelShow(false);
      });

      window.ChannelIO('onHideMessenger', () => {
        setIsChannelShow(true);
      });
      window.ChannelIO('onBadgeChanged', (unread, alert) => {
        setIsChannelShow(unread === 0 || alert === 0);
      });
    } else {
      setIsChannelShow(false);
    }
  }, [enableChannelTalk]);

  return (
    <>
      <Script
        id="channeltalk"
        dangerouslySetInnerHTML={{
          __html: CHANNEL_TALK_LOADING_SCRIPT,
        }}
      />
      <button
        className={clsx(
          'custom-channel-talk hidden md:block fixed bottom-14 right-0.5 z-[10000] size-[38px] shadow transition-transform duration-100 ease-in-out rounded-lg',
          isChannelShow ? 'scale-100 hover:scale-[110%] opacity-100' : 'scale-0 opacity-0'
        )}
      >
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="38" height="38" rx="8" fill="url(#paint0_linear_8430_23564)" />
          <path
            d="M18.9998 7.91663C25.1208 7.91663 30.0836 12.8786 30.0837 18.9996C30.0837 20.6075 29.7377 22.1343 29.1218 23.5133C28.9481 23.9854 28.7527 24.8732 28.9187 25.6979L29.4656 27.7555C29.7411 28.7936 28.793 29.7427 27.7546 29.4684L25.7253 28.9313C24.8423 28.7527 23.9198 28.9542 23.5417 29.108C22.1552 29.732 20.6188 30.0836 18.9998 30.0836C12.8787 30.0834 7.91675 25.1207 7.91675 18.9996C7.91692 12.8787 12.8789 7.9168 18.9998 7.91663ZM15.6619 19.7701C15.3753 19.4 14.8544 19.2387 14.4509 19.4762L12.8347 20.4274C12.4767 20.6384 12.3366 21.091 12.5544 21.4449C13.8667 23.5773 16.3376 25.1333 18.9998 25.1334C21.6589 25.1334 24.1277 23.5813 25.4412 21.4528C25.6614 21.0959 25.5169 20.6388 25.1531 20.4303L23.5427 19.5084C23.1397 19.2777 22.6253 19.4411 22.3396 19.8073C21.5709 20.7926 20.2765 21.6481 18.9998 21.6481C17.7253 21.648 16.4315 20.7651 15.6619 19.7701Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8430_23564"
              x1="19"
              y1="0"
              x2="19"
              y2="38"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#572DFF" />
              <stop offset="1" stopColor="#572DFF" />
            </linearGradient>
          </defs>
        </svg>
      </button>
    </>
  );
}

export function openChannelTalk(): void {
  window.ChannelIO?.('openChat', '', '');
}

export function hideChannelTalk(): void {
  window.ChannelIO?.('hideMessenger');
}
